import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_LINE_UP_BUQUES } from '../../../../config/forms'
import * as actions from '../../actions/TablaBuquesAnunciadosActions'
import AnunciarBuqueDialogView from './AnunciarBuqueDialogView'
import DialogView from '../../../Dialogos/DialogView'
import { CircularProgress } from '@material-ui/core'

function DialogoAnuncioBuqueUpdate (props) {
  const { fechaAnuncio, anuncioInicial, cancelCallback, confirmCallback, getAnuncioBuquePorFecha, change: formChange } = props
  const [fechaDesde, setFechaDesde] = useState()
  const [fechaHasta, setFechaHasta] = useState()

  useEffect(() => {
    async function getAnuncio () {
      getAnuncioBuquePorFecha(fechaAnuncio)
    }
    getAnuncio()
  }, [getAnuncioBuquePorFecha, fechaAnuncio])

  useEffect(() => {
    if (anuncioInicial) {
      const exportador = `${anuncioInicial.nombreExportador} - ${anuncioInicial.exportador}`
      const agenciaMaritima = anuncioInicial.nombreAgenciaMaritima ? `${anuncioInicial.nombreAgenciaMaritima} - ${anuncioInicial.agenciaMaritima}` : null
      const agenciaDeEstiba = anuncioInicial.nombreAgenciaDeEstiba ? `${anuncioInicial.nombreAgenciaDeEstiba} - ${anuncioInicial.agenciaDeEstiba}` : null

      setFechaDesde(moment(anuncioInicial.fechaEstimadaDeArriboDesde).format('DD/MM/YYYY'))
      setFechaHasta(moment(anuncioInicial.fechaEstimadaDeArriboHasta).format('DD/MM/YYYY'))
      formChange('fechaDeArriboDesdeOld', moment(anuncioInicial.fechaEstimadaDeArriboDesde).format('DD/MM/YYYY'))
      formChange('fechaDeArriboDesde', moment(anuncioInicial.fechaEstimadaDeArriboDesde).format('DD/MM/YYYY'))
      formChange('fechaDeArriboHasta', moment(anuncioInicial.fechaEstimadaDeArriboHasta).format('DD/MM/YYYY'))
      formChange('fechaPlanDeEmbarque', anuncioInicial.fechaPlanDeEmbarque)
      formChange('agencia', agenciaMaritima)
      formChange('cereal', anuncioInicial.claveCereal)
      formChange('claveCereal', anuncioInicial.claveCereal)
      formChange('exportador', exportador)
      formChange('giro', anuncioInicial.giro)
      formChange('nombre', anuncioInicial.nombre)
      formChange('nombreCorto', anuncioInicial.nombreCorto)
      formChange('nombreCortoInicial', anuncioInicial.nombreCorto)
      formChange('paisDestino', anuncioInicial.paisDestino)
      formChange('toneladas', anuncioInicial.toneladas)
      formChange('estado', anuncioInicial.claveEstado)
      formChange('agenciaDeEstiba', agenciaDeEstiba)
      formChange('diasEstimadosCarga', anuncioInicial.diasEstimadosCarga)
    }
  }, [anuncioInicial, formChange])

  const handleCancel = () => {
    props.resetAnuncioInicial()
    cancelCallback()
  }

  const handleSubmit = () => {
    props.resetAnuncioInicial()
    confirmCallback()
  }

  return (
    <>
      { (fechaDesde && fechaHasta) ? <DialogView
        confirmCallback={handleSubmit}
        cancelCallback={handleCancel}
        title='Edición anuncio buque'
        content={
          <AnunciarBuqueDialogView fechaDesde={fechaDesde} fechaHasta={fechaHasta} />
        }
      />
        : <div style={{ padding: '10% 0', display: 'flex', justifyContent: 'center' }} >
          <CircularProgress />
        </div>
      }
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    anuncioInicial: state.buque.anuncioInicial
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_LINE_UP_BUQUES,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: true,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(DialogoAnuncioBuqueUpdate))
